export enum ApplicationStatusEnum {
  PendingYourReview = 194,
  Approved          = 195,
  Rejected          = 196,
}

export enum PaymentStatusEnum {
  AwaitingPayment = 197,
  Paid            = 198,
  NotRequired     = 199,
}

export const ApplicationStatusLabel: Record<number, string> = {
  [ApplicationStatusEnum.PendingYourReview]: 'Pending Your Review',
  [ApplicationStatusEnum.Approved]: 'Approved',
  [ApplicationStatusEnum.Rejected]: 'Rejected',
};

export const PaymentStatusLabel: Record<number, string> = {
  [PaymentStatusEnum.AwaitingPayment]: 'Awaiting Payment',
  [PaymentStatusEnum.Paid]: 'Paid',
  [PaymentStatusEnum.NotRequired]: 'Not Required',
};

export interface ITicketVariant {
    discountGroupId: number | null;
    title: string;
    price: number | null;
    isFreeTicket: boolean;
    quantity: number | null;
}

export interface IActivityLog{
    activityId: number;
    communityId: number | null;
    fullName: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    comments: string;
    notes: string;
    date: Date | null;
    activityType: string;
    activityTypeId: number
    campaignId: number | null;
    campaignDisplayId: string;
    campaignDisplayName: string;
    campaignTypeId?:number;
    itemId: number | null;
    itemDisplayId: string;
    itemDisplayName: string;
    documentBlobUrl: string;
    organizationBusinessName: string;
    amount: number | null;
    approvedPaymentAmount: number | null;
    paymentMethodName: string;
    itemEventEndDate?:string;
    itemEventStartDate?:string;
    itemDateEventType?:string;
    hasEventTimeEntered?:boolean;
    donationSource?:string;
    disbursementDate?:string;
    netAmount:number | null;
    disbursementDetails?:string;
    isLogDeletionAllowed?: boolean;
    isItemDeletionAllowed?: boolean;
    itemStatusId?:number
    volunteerShiftString?: string;
    volunteerShiftEndDateTime?: string;
    volunteerShiftStartDateTime?: string;
    volunteerShiftName?: string;
    volunteerHoursWorked?: number | null | undefined;
    isVolunteerPresent?: boolean | null | undefined;
    parentItemId?: number;
    parentItemUniqueId?:string;
    parentItemName?:string;
    dedicatedTo?:string;
    donatedBy?:string;
    timeZone?: number | null;
    numberOfTickets?: number | null;
    checkedInTickets?: number | null;
    applicationStatus?: ApplicationStatusEnum | null;
    ticketBreakdownText?: string | null;
    ticketVariants?: ITicketVariant[] | null;
    paymentStatus?: PaymentStatusEnum | null;
    paymentDate?: Date | string | null;
}

export interface IActivityLogStats {
  totalAvailableItems?: number | null;
  totalActivities?: number | null;
  totalActivitiesLast30Days?: number | null;
  totalCampaigns?: number | null;
  totalRevenue?: number | null;
  revenueLast30Days?: number | null;
  pendingReview?: number | null;
  approvedApplications?: number | null;
  rejectedApplications?: number | null;
  awaitingPayment?: number | null;
  paidApplications?: number | null;
}